import type { LoaderFunctionArgs } from '@remix-run/node';
import { type GetBuildHubFileCommentsQueryVariables } from 'generated/graphql';
import { getBuildHubItemComments } from '@modules/build-hub-comment/api/get-build-hub-item-comments';
import { json } from '@remix-run/node';

export const LIST_BUILD_HUB_ITEM_COMMENTS_API_ROUTE =
    '/remix-api/app/build-hub-item-comments';

export const loader = async ({ params, context }: LoaderFunctionArgs) => {
    const id = params.id;

    if (!id) {
        throw new Response('Comment target ID required', { status: 400 });
    }

    const variables: GetBuildHubFileCommentsQueryVariables = {
        CommentTargetID: id,
    };

    const comments = await getBuildHubItemComments({
        ...context,
        ...variables,
    });

    return json({ comments });
};
